import downloadDoc from './downloadDoc'
export default downloadDoc
